import { appConfig } from '../config';

let authProvider: any = null;

export class ApiError extends Error {
    constructor(
        message: string,
        public status: number,
        public state?: string,
        public details?: any
    ) {
        super(message);
        this.name = 'ApiError';
    }
}

// Function to set the auth provider reference
export const setAuthProvider = (provider: any) => {
    authProvider = provider;
};

// // Enhanced apiRequest with automatic token expiration handling
// export const apiRequest = async (
//     url: string,
//     options: RequestInit = {},
//     skipAuthRedirect: boolean = false
// ): Promise<any> => {
//     const defaultOptions: RequestInit = {
//         credentials: 'include',
//         ...options,
//     };
//
//     try {
//         const response = await fetch(url, defaultOptions);
//
//         // Check for authentication/authorization errors
//         if (response.status === 401 || response.status === 403) {
//             if (!skipAuthRedirect && authProvider) {
//                 // Token has expired or user is no longer authorized
//                 authProvider.handleTokenExpiration();
//                 return null;
//             }
//             throw new Error('Unauthorized');
//         }
//
//         if (!response.ok) {
//             const errorText = await response.text();
//             throw new Error(`HTTP ${response.status}: ${errorText}`);
//         }
//
//         const contentType = response.headers.get('content-type');
//         if (contentType && contentType.includes('application/json')) {
//             return await response.json();
//         }
//
//         return await response.text();
//     } catch (error) {
//         console.error('API request failed:', error);
//         throw error;
//     }
// };

export async function apiRequest(url: string, options?: RequestInit) {

    const response = await fetch(url, { credentials: "include", ...options });

    if (response.status === 401 || response.status === 403) {
        throw new ApiError('Unauthorized', response.status);
    }

    if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new ApiError(errorData.message || 'Request failed',
            response.status, errorData.state, errorData);
    }

    return response.json();
}

// Utility for making authenticated requests with better error handling
export const authenticatedRequest = async (
    endpoint: string,
    options: RequestInit = {}
): Promise<any> => {
    const url = endpoint.startsWith('http') ? endpoint : `${appConfig.backendUrl}${endpoint}`;
    return apiRequest(url, options);
};

// Utility for checking if user is still authenticated
export const checkAuthStatus = async (skipAuthRedirect: boolean = false): Promise<boolean> => {
    try {
        await apiRequest(`${appConfig.backendUrl}/api/session/status`);

        const response = await fetch(`${appConfig.backendUrl}/api/session/status`,
            { credentials: "include" });

        if (response.status === 401 || response.status === 403) {
            if (!skipAuthRedirect && authProvider) {
                authProvider.handleTokenExpiration();
                return false;
            }
            throw new Error('Unauthorized');
        }

        if (!response.ok) {
            const errorData = await response.json().catch(() => ({}));
            const error = new Error(errorData.message || 'Request failed');
            (error as any).status = response.status;
            (error as any).details = errorData;
            throw error;
        }

        return true;

    } catch (error) {
        console.error('DAMN: ', error);
        return false;
    }
};